import React from "react";
import PropTypes from "prop-types";
import { PlusCircle } from "react-feather";

// Common icons

export const SuccessIcon = (props) => {
    const { viewBox } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
            viewBox={viewBox}
        >
            <rect width="32" height="32" fill="#DDF5DC" rx="16"></rect>
            <path
                fill="#54CD51"
                d="M23.025 9.26L12.75 19.535 8.975 15.76a.469.469 0 00-.663 0l-1.105 1.105a.469.469 0 000 .663l5.212 5.212c.183.183.48.183.663 0l11.711-11.712a.469.469 0 000-.663L23.688 9.26a.469.469 0 00-.663 0z"
            ></path>
        </svg>
    );
};

export const WarningIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
            viewBox="0 0 32 32"
        >
            <rect width="32" height="32" fill="#FEEDCC" rx="16"></rect>
            <path
                stroke="#F8A700"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 14.125v3.125M14.918 9.124L8.045 20.998a1.25 1.25 0 001.082 1.876h13.746a1.25 1.25 0 001.082-1.876L17.082 9.124a1.25 1.25 0 00-2.164 0v0z"
            ></path>
            <path
                fill="#F8A700"
                d="M16 21a.937.937 0 100-1.875A.937.937 0 0016 21z"
            ></path>
        </svg>
    );
};

export const DangerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
            viewBox="0 0 32 32"
        >
            <rect width="32" height="32" fill="#FAD9D9" rx="16"></rect>
            <g
                stroke="#E73F3F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                clipPath="url(#clip0)"
            >
                <path d="M22.142 9.808L9.62 22.329M22.142 22.33L9.62 9.807"></path>
            </g>
            <defs>
                <clipPath id="clip0">
                    <path
                        fill="#fff"
                        d="M0 0H16V16H0z"
                        transform="translate(8 8)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export const InfoIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
            viewBox="0 0 32 32"
        >
            <rect width="32" height="32" fill="#DBDBDB" rx="16"></rect>
            <path
                fill="#4C4949"
                d="M16 6.313a9.687 9.687 0 100 19.375A9.687 9.687 0 0025.688 16c0-5.348-4.338-9.688-9.688-9.688zm0 17.5A7.808 7.808 0 018.187 16 7.81 7.81 0 0116 8.187 7.81 7.81 0 0123.813 16 7.808 7.808 0 0116 23.813zm0-13.204a1.64 1.64 0 110 3.282 1.64 1.64 0 010-3.282zm2.188 9.922c0 .26-.21.469-.47.469h-3.437a.469.469 0 01-.469-.469v-.937c0-.26.21-.469.47-.469h.468v-2.5h-.469a.469.469 0 01-.469-.469v-.937c0-.26.21-.469.47-.469h2.5c.258 0 .468.21.468.469v3.906h.469c.259 0 .468.21.468.469v.937z"
            ></path>
        </svg>
    );
};

export const Klarna = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="45"
            height="25"
            fill="none"
            viewBox="0 0 45 25"
        >
            <path fill="url(#pattern0)" d="M0 0H45V25H0z"></path>
            <defs>
                <pattern
                    id="pattern0"
                    width="1"
                    height="1"
                    patternContentUnits="objectBoundingBox"
                >
                    <use
                        transform="scale(.02222 .04)"
                        xlinkHref="#image0"
                    ></use>
                </pattern>
                <image
                    id="image0"
                    width="45"
                    height="25"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAZCAYAAACl8achAAACBElEQVRYCe2YvUoDQRSFt1fEIoJC0iWkUvzBShAtLKxEbSOWaiMWVjamsROyrTbauA+QPknhA+w2voPPYDPyTXKWySabRDBxIymGmTv3zL3nnr2zsOt5nueZl3DRBK2aCZqhCVome8PyqsETvh3CWSWbFLAZWuImaPjZUzZJ1rUbvpfdlnCJuutm6E2Xym3yM9KTemr/Q+n3u0dTPT0zn/5b/L72K1d2DyVfL27j9aSUTebpUfr+pGLmF+YM5AXGLuYL1t5bXbd++f5iHkoaZSF9vnuQSvrj4cl8PdfjIocVAr4fZtQ4A0nTIitLuS7lXaVJUsoXrJ/ChIUQNj4GT41zsoVFELD1m2p8Vj7mfoWxl0q6VrmMA10fHscBXNKQXM7lDFgwJFIyrWkritM5cODxc17CgKMInqjO/pg01ROIAFKEIEqOemk+cPh0D3QuaYNRHPKJ5GaxbM/LTs6pShNMAaWIkpMM9Zi5uAqqVsHGR4HysU7aLmnUB8vdcOOQx32TgRlIGoDeJlulsg0qpfFpjU+JIIJvVNJgpez+2kZXHAnjFgu+hzStAIgDABj0GXv46EkFQRWKwj7a3rFDPmb3LrBO2sISRzncOOxju+3Zl7SIZnnuUTrLZMVtRlpKjHtG6WjcSX45fuRN5zdi+/fBtKgdJX4j2K/yrJKPbEd0/nt8A0QXib0zL5HxAAAAAElFTkSuQmCC"
                ></image>
            </defs>
        </svg>
    );
};

export const PayPal = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="45"
            height="29"
            fill="none"
            viewBox="0 0 45 29"
        >
            <path fill="url(#pattern0)" d="M0 0H45V28.235H0z"></path>
            <defs>
                <pattern
                    id="pattern0"
                    width="1"
                    height="1"
                    patternContentUnits="objectBoundingBox"
                >
                    <use
                        transform="scale(.0196 .03125)"
                        xlinkHref="#image0"
                    ></use>
                </pattern>
                <image
                    id="image0"
                    width="51"
                    height="32"
                    xlinkHref="data:image/png;base64,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"
                ></image>
            </defs>
        </svg>
    );
};

export const GradientPlusIcon = () => {
    return (
        <>
            <PlusCircle style={{ stroke: "url(#right_gradient)" }} />
            <RightGradient />
        </>
    );
};

export const GradientIcon = ({ icon, ...props }) => {
    let Icon = icon;
    return (
        <>
            <Icon style={{ stroke: "url(#right_gradient)" }} {...props} />
            <RightGradient />
        </>
    );
};

export const RightGradient = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="0"
            style={{ width: "0" }}
        >
            <linearGradient
                id="right_gradient"
                x1="17.665"
                x2="28.56"
                y1="-7.103"
                y2="-7.103"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#19C981"></stop>
                <stop offset="0.557" stopColor="#39E486"></stop>
                <stop offset="1" stopColor="#00FF46"></stop>
            </linearGradient>
        </svg>
    );
};

// Proptypes

SuccessIcon.propTypes = {
    viewBox: PropTypes.string,
};

SuccessIcon.defaultProps = {
    viewBox: "0 0 32 32",
};

GradientIcon.propTypes = {
    icon: PropTypes.object.isRequired,
};

// Custom feather icons
export { default as AddressBook } from "./AddressBook";
export { default as Shop } from "./Shop";
export { default as CloseIcon } from "./CloseIcon";
